import { ensurePaginationPageSizeSelector } from "./paginationPageSizeSelector.js";
import { sanitizeColDef, sanitizeColDefs } from "./sanitizeColDefs.js";

const SINGLE_COL_DEF_OPTIONS = ["defaultColDef", "autoGroupColumnDef", "selectionColumnDef"];

/**
 * Prepare grid options for DataTable and DataTableV2 before they reach ag-grid-vue.
 * Column definitions (including default, auto-group, and selection defs) are
 * allowlisted. paginationPageSize is added to the page-size selector when missing.
 * The input options object is not mutated.
 */
export function prepareTableGridOptions(options) {
  if (!options || typeof options !== "object") return options;

  const next = { ...options };
  if (Array.isArray(next.columnDefs)) {
    next.columnDefs = sanitizeColDefs(next.columnDefs);
  }
  for (const key of SINGLE_COL_DEF_OPTIONS) {
    if (next[key] && typeof next[key] === "object") {
      next[key] = sanitizeColDef(next[key]);
    }
  }
  return ensurePaginationPageSizeSelector(next);
}
